/**
 * Created by slava on 9/8/17
 */

const CellBoosterView = FieldBoosterView.extend({
    setAnimationZOrder: function (animation) {
        animation.setLocalZOrder(100);
    },

    onHurtCellsAnimation: function (cells) {
        const cell = cells[0];
        const position = BaseCellView.alignInTheGrid(cell.x, cell.y);
        const fieldView = Game.currentGame.field.onGetView();

        const animation = new cleverapps.Spine(bundles.game.jsons.cellbooster_spine_json);
        this.setAnimationZOrder(animation);
        animation.setPosition(position);
        fieldView.addChild(animation);

        animation.setAnimation(0, "animation", false);
        animation.setCompleteListener(() => {
            animation.runAction(new cc.Sequence(
                new cc.CallFunc(() => {
                    if (Game.currentGame) {
                        Game.currentGame.bigExplode();
                    }
                }),
                new cc.RemoveSelf()
            ));
        });

        cleverapps.effects.fire("match3.booster.spoon.use");
    }
});